export const en = {
  // Navigation & Common
  navigation: {
    dashboard: "Dashboard",
    quotations: "Quotations", 
    projects: "Projects",
    invoices: "Invoices",
    tasks: "Tasks",
    certificates: "Certificates",
    clients: "Clients",
    users: "Users",
    templates: "Templates",
    logout: "Logout"
  },
  
  // Common Actions
  actions: {
    create: "Create",
    edit: "Edit", 
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    submit: "Submit",
    search: "Search",
    filter: "Filter",
    export: "Export",
    import: "Import",
    send: "Send",
    approve: "Approve",
    reject: "Reject",
    refresh: "Refresh"
  },

  // Clients
  clients: {
    title: "Clients", 
    createClient: "Create Client",
    editClient: "Edit Client",
    clientList: "Client List",
    clientDetails: "Client Details"
  },

  // Projects  
  projects: {
    title: "Projects",
    createNew: "Create New Project",
    editProject: "Edit Project",
    projectList: "Project List",
    projectDetails: "Project Details", 
    assignedEngineer: "Assigned Engineer",
    progress: "Progress",
    startDate: "Start Date"
  },

  // Invoices
  invoices: {
    title: "Invoices",
    createNew: "Create New Invoice", 
    editInvoice: "Edit Invoice",
    invoiceList: "Invoice List",
    invoiceNumber: "Invoice Number",
    issueDate: "Issue Date",
    paidDate: "Paid Date"
  },

  // Forms & Fields
  fields: {
    name: "Name",
    description: "Description",
    status: "Status", 
    dueDate: "Due Date",
    createdDate: "Created Date",
    client: "Client",
    project: "Project",
    assignedTo: "Assigned To",
    amount: "Amount",
    email: "Email",
    phone: "Phone", 
    address: "Address"
  }
};